import React from 'react'
import styles from './styles/ratings-range-graphic.module.scss'
import { mapRange } from '../../utils/index'
import {WTN_SCALE_HIGH ,WTN_SCALE_LOW} from '../../constants/global'

interface Props {
  low: string |  undefined
  high: string |  undefined
}

const RatingsRangeGraphic: React.FC<Props> = ({ low, high }) => {
  return (<>
    { low && high ?  

    <div className={styles.wrapper}>
      <h2>{low} - {high}</h2>
      <div className={styles.highLowGraph}>
        <p className={styles.label}>{WTN_SCALE_LOW}</p>
        <div className={styles.highLowLine}>
          <div className={styles.highLowRangeGradient} style={{ width: `${mapRange(+high, WTN_SCALE_LOW, WTN_SCALE_HIGH, 0, 100) - mapRange(+low, WTN_SCALE_LOW, WTN_SCALE_HIGH, 0, 100)}%`, left: `${mapRange(+low, WTN_SCALE_LOW, WTN_SCALE_HIGH, 0, 100)}%` }}></div>
        </div>
        <p className={styles.label}>{WTN_SCALE_HIGH}</p>
      </div>
    </div>
      :
      <div className={styles.wrapper}>
        <p className={styles.message}>No matches played</p>
      </div>
    }
  </>

  )
}

export default RatingsRangeGraphic
